<template>
  <div id="app">
    <div class="container-fluid" @click="minUrlFalse">
      <top-nav ref="top"></top-nav>
      <router-view />
      <bottom :shadow="shadow"></bottom>

      <!--健康管理AI解决方案限时免费领取  -->
      <div
        class="submit_form"
        v-if="isFormBox"
        :style="flagMobile ? 'right:5px;' : ''"
      >
        <div
          class="form_box"
          :style="
            flagMobile
              ? 'max-height:400px;max-width:95%;overflow-y: auto;overflow-x: hidden;'
              : ''
          "
        >
          <div class="close_form">
            <i class="el-icon-close" @click="isFormBox = false"></i>
          </div>
          <h5 class="form_title">
            全生命周期AI健康管理解决方案
            <div>限时免费领取</div>
          </h5>
          <div>
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              :rules="rules"
              label-width="15px"
            >
              <el-form-item label=" " prop="member_name">
                <el-input
                  class="ipt_w1"
                  v-model="ruleForm.member_name"
                  clearable
                  placeholder="请输入姓名"
                ></el-input>
                <el-form-item
                  label=""
                  prop="sex"
                  style="display: inline-block; margin-left: 10px"
                >
                  <el-radio-group v-model="ruleForm.sex">
                    <el-radio label="1">先生</el-radio>
                    <el-radio label="2">女士</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form-item>
              <el-form-item label=" " prop="member_mobile">
                <el-input
                  class="ipt_w1"
                  maxlength="11"
                  v-model="ruleForm.member_mobile"
                  clearable
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item label=" ">
                <el-input
                  class="ipt_w2"
                  v-model="ruleForm.company_name"
                  clearable
                  placeholder="请输入企业名称"
                  :style="flagMobile ? 'width:200px;' : ''"
                ></el-input>
              </el-form-item>
              <el-form-item label=" " prop="address">
                <!-- <div>(请输入您所在城市或意向拓展区域)</div> -->
                <el-input
                  class="ipt_w2"
                  v-model="ruleForm.address"
                  clearable
                  placeholder="请输入您所在城市或意向拓展区域"
                  :style="flagMobile ? 'width:200px;' : ''"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="btn"
                  type="primary"
                  @click="submitForm('ruleForm')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          
          <div class="form_bottom">
            <div style="flex: 2">
              <div>
                <img
                  class="wx_img"
                  src="https://img.duoduiduo.com/first-aid/iphone_lx.png"
                  alt=""
                />
              </div>
              <p class="wx_p">微信详询请扫码</p>
              <div class="contactme" @click="goConcat('18676562256')">
                <span>业务联系电话</span>
                <div>18676562256 陈先生</div>
              </div>
              <div class="contactme" @click="goConcat('4008600668')">
                <span>全国热线</span>
                <div>400-8600-668</div>
              </div>
            </div>
            <div class="form_bottom_right">
              <img src="./assets/images/smile_ddd.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div @click="aaaa" class="layer-2" id="YSF-BTN-HOLDER" v-if="!isFormBox">
        <div id="YSF-CUSTOM-ENTRY-2" class="YSF-CUSTOM-ENTRY">
          <img src="../src/assets/images/sdk_res_kefu_custom_2.png" />
        </div>
        <span id="YSF-BTN-CIRCLE"></span>
        <div id="YSF-BTN-BUBBLE">
          <div id="YSF-BTN-CONTENT"></div>
          <span id="YSF-BTN-ARROW"></span><span id="YSF-BTN-CLOSE"></span>
        </div>
      </div>

      <el-dialog
        z-index="999"
        append-to-body
        title=""
        :visible.sync="dialogVisible"
        :width="flagMobile ? '95%' : '450px'"
        :before-close="handleClose"
      >
        <div>
          <img
            :style="flagMobile ? 'width:250px;' : 'width:350px;'"
            src="./assets/images/success_form.png"
            alt=""
          />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottom from "@/components/bottom";

export default {
  name: "App",
  components: {
    topNav,
    bottom,
  },
  data() {
    // 自定义验证
    const validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
      }
    };
    return {
      shadow: true,
      ruleForm: {
        sex: "1",
      },
      rules: {
        member_name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        member_mobile: [
          { required: true, trigger: "blur", validator: validPhone },
        ],
        address: [
          {
            required: true,
            message: "请输入您所在城市或意向拓展区域",
            trigger: "blur",
          },
        ],
      },
      isFormBox: true,
      dialogVisible: false,
      flagMobile: false,
    };
  },
  created() {
    this.getToken();
    this.flagMobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
  },
  methods: {
    goConcat(mobile) {
      if (this.flagMobile) {
        window.location.href = `tel:${mobile}`;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendHttp({
            method: "post",
            url: `${this.proUrl}/activityrecord/joinhaas`,
            data: {
              activity_id: "17",
              ...this.ruleForm,
            },
          }).then((res) => {
            if (res.code == "0") {
              this.dialogVisible = true;
              this.ruleForm = { sex: "1" };
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    aaaa() {
      this.isFormBox = true;
      // window.location.href =
      //   "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIyOTQ5ODI1NA==#wechat_redirect";
    },
    //获取token
    getToken() {
      let token = window.localStorage.getItem("token");
      this.sendHttp({
        method: "post",
        url: `${this.accountUrl}/api/accesstoken`,
        data: {},
      }).then((res) => {
        if (res.code == "0") {
          // 把获取到的存到本地缓存
          window.localStorage.setItem("token", res.data.token);
          //获取轮播
          this.$refs.top.getBanner();
        }
      });
    },

    minUrlFalse() {
      this.$refs.top.fatherMinUrl();
    },
  },
};

window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
</script>

<style lang="less">
@import "assets/style/common";

#YSF-BTN-HOLDER {
  position: fixed;
  max-width: 70px;
  max-height: 70px;
  right: 30px;
  bottom: 50px;
  cursor: pointer;
  overflow: visible;
  // filter: alpha(opacity = 100);
  opacity: 1;
  z-index: 9990;
}
#YSF-CUSTOM-ENTRY-2 {
  position: relative;
  width: auto;
  background-color: #f2a552;
  border-radius: 8px;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.25);
}
#YSF-CUSTOM-ENTRY-2 img {
  width: 58px;
  height: auto;
}

.submit_form {
  position: fixed;
  right: 30px;
  bottom: 50px;
  z-index: 99;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  .el-form-item__content,
  .el-form-item__label {
    line-height: 35px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #f4690c;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #f4690c;
    background: #f4690c;
  }
  // .label_requier_name {
  //   padding: 0 3px;
  //   color: red;
  // }
  // .el-form-item{
  //   margin-bottom:5px;
  // }
  .ipt_w1 {
    width: 150px;
  }
  .ipt_w2 {
    width: 300px;
  }
  .close_form {
    text-align: right;
    padding: 5px;
    .el-icon-close {
      font-weight: bold;
      font-size: 20px;
    }
  }
  .btn {
    background: #f4690c;
    border: none;

    width: 150px;
  }
  .form_box {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
    .form_title {
      text-align: left;
      color: #ff6111;
      font-weight: 600;
      margin-bottom: 20px;
      margin-left: 15px;
    }
    .form_bottom {
      display: flex;
      margin-left: 15px;
      margin-top: 10px;
      .wx_img {
        width: 110px;
        height: 110px;
      }
      .wx_p {
        font-size: 16px;
        margin-top: 5px;
      }
      .contactme {
        font-weight: bold;
        margin-bottom: 10px;
        color: #5f5d5d;
        span {
          color: #ff6111;
          font-size: 14px;
        }
      }
      .contactme:nth-last-of-type(1) {
        margin-bottom: 0;
      }
      .form_bottom_right {
        flex: 1;
        img {
          width: 150px;
          height: 200px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue